// Opt-in description preview. Without JavaScript, all content stays readable.
class CamixaHalfReveal extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.camixa-half-reveal__content');
    this.inner = this.querySelector('.camixa-half-reveal__inner');
    this.button = this.querySelector('button');
    if (!this.content || !this.inner || !this.button) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.details = this.closest('details');
    this.details?.addEventListener('toggle', () => {
      if (!this.details.open) this.setExpanded(false);
      else this.measure();
    }, { signal });
    // Reset before a user closes the row, including rapid close/reopen clicks.
    this.details?.querySelector('summary')?.addEventListener('click', () => {
      if (this.details.open) this.setExpanded(false);
    }, { signal });
    this.button.addEventListener('click', () => this.setExpanded(!this.hasAttribute('data-expanded')), { signal });
    // Reveal clipped links before they receive visible keyboard interaction.
    this.content.addEventListener('focusin', () => this.setExpanded(true), { signal });
    this.observer = new ResizeObserver(() => this.measure());
    this.observer.observe(this.inner);
    this.measure();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  measure() {
    // Closed details have no measurable layout. Measure on opening instead.
    if (this.details && !this.details.open) return;
    const height = parseFloat(getComputedStyle(this).getPropertyValue('--preview-height')) || 100;
    const overflow = this.inner.getBoundingClientRect().height > height + 1;
    this.toggleAttribute('data-overflow', overflow);
    this.button.hidden = !overflow;
    if (!overflow) this.setExpanded(false);
  }

  setExpanded(expanded) {
    this.toggleAttribute('data-expanded', expanded);
    this.button.setAttribute('aria-expanded', String(expanded));
    this.button.querySelector('[data-more]').hidden = expanded;
    this.button.querySelector('[data-less]').hidden = !expanded;
  }
}

if (!customElements.get('camixa-half-reveal')) customElements.define('camixa-half-reveal', CamixaHalfReveal);
